export default "__VITE_ASSET__de4a63ea__"